import * as Sentry from '@sentry/react';

export const guard = f => {
  try {
    f();
  } catch (err) {
    Sentry.captureException(err);
  }
};
